<template>
    <div class="text-center">
        <div v-if="dialog == true" class="modal fade show" id="Modal" tabindex="-1" role="dialog" aria-labelledby="ModalLabel" style="display: block; padding-right: 12px;">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="ModalLabel">{{ actionType }} nueva regla de fees</h5>
                    </div>
                    <div class="modal-body">
                        <slot name="body">
                            <form class="container pl-50">
                            <div>
                                <div class="mt-3">
                                    <label class="text-left w-100" style="text-align: left;"><b>Name*</b></label>
                                    <div class="mt-3">
                                        <textarea class="border w-100 p-2" v-model="name" placeholder="Rule Name"></textarea>
                                    </div>
                                </div>

                                <div class="mt-3">
                                    <label class="text-left w-100" style="text-align: left;"><b>Remite</b></label>
                                    <div class="mt-3">
                                        <textarea class="border w-100 p-2" v-model="remite" placeholder="Remite"></textarea>
                                    </div>
                                </div>

                                <div class="mt-3">
                                    <label class="text-left w-100" style="text-align: left;"><b>Provider</b></label>
                                    <div class="mt-3">
                                        <select v-model="provider_id" class="border w-100 p-2" @change="updateProviderIATA()">
                                        <option v-for="option in providers" v-bind:value="option.value" :key="option.value">
                                            {{ option.text }}
                                        </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="mt-3">
                                    <label class="text-left w-100" style="text-align: left;"><b>Provider IATA</b></label>
                                    <div class="mt-3">
                                        <select v-model="provider_iata" class="border w-100 p-2">
                                        <option v-for="option in provider_iatas" v-bind:value="option.value" :key="option.value">
                                            {{ option.text }}
                                        </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="mt-3">
                                    <label class="text-left w-100" style="text-align: left;"><b>System*</b></label>
                                    <div class="mt-3">
                                        <select v-model="system" class="border w-100 p-2">
                                        <option v-for="option in systems" v-bind:value="option.value" :key="option.value">
                                            {{ option.text }}
                                        </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="mt-3" >
                                    <label class="text-left w-100" style="text-align: left;"><b>Market Id</b></label>
                                    <div class="mt-3">
                                        <select v-model="market_id" class="border w-100 p-2">
                                        <option v-for="option in markets" v-bind:value="option.value" :key="option.value">
                                            {{ option.text }}
                                        </option>
                                        </select>
                                    </div>
                                </div>


                                <div class="mt-3" >
                                    <label class="text-left w-100" style="text-align: left;"><b>Route Type*</b></label>
                                    <div class="mt-3">
                                        <select v-model="route_type" class="border w-100 p-2">
                                        <option v-for="option in route_types" v-bind:value="option.value" :key="option.value">
                                            {{ option.text }}
                                        </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="mt-3" >
                                    <label class="text-left w-100" style="text-align: left;"><b>Airline IATA</b></label>
                                    <div class="mt-3">
                                        <textarea class="border w-100 p-2" v-model="airline_iata" placeholder="IATA"></textarea>
                                    </div>
                                </div>

                                <div class="mt-3" >
                                    <label class="text-left w-100" style="text-align: left;"><b>Geounit Origin ID</b></label>
                                    <div class="mt-3">
                                        <select v-model="geounit_origin_id" class="border w-100 p-2">
                                        <option v-for="option in geounits_origin_id" v-bind:value="option.value" :key="option.value">
                                            {{ option.text }}
                                        </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="mt-3" >
                                    <label class="text-left w-100" style="text-align: left;"><b>Geounit Destination ID</b></label>
                                    <div class="mt-3">
                                        <select v-model="geounit_destination_id" class="border w-100 p-2">
                                        <option v-for="option in geounits_destination_id" v-bind:value="option.value" :key="option.value">
                                            {{ option.text }}
                                        </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="mt-3" >
                                    <label class="text-left w-100" style="text-align: left;"><b>Application Fee*</b></label>
                                    <select v-model="application_fee" class="border w-100 p-2">
                                        <option v-for="option in application_fees" v-bind:value="option.value" :key="option.value">
                                            {{ option.text }}
                                        </option>
                                    </select>
                                </div>

                                <div class="mt-3" >
                                    <label class="text-left w-100" style="text-align: left;"><b>Passenger Type*</b></label>
                                    <div class="mt-3">
                                        <input type="number" class="border w-100 p-2" v-model="passenger_type" min="1" max="2"/>
                                    </div>
                                </div>

                                <div class="mt-3" >
                                    <label class="text-left w-100" style="text-align: left;"><b>Fee Type*</b></label>
                                    <select v-model="fee_type" class="border w-100 p-2">
                                        <option v-for="option in fee_types" v-bind:value="option.value" :key="option.value">
                                            {{ option.text }}
                                        </option>
                                    </select>
                                </div>

                                <div class="mt-3" >
                                    <label class="text-left w-100" style="text-align: left;"><b>Adult Fee*</b></label>
                                    <div class="mt-3">
                                        <input type="number" step="0.01" class="border w-100 p-2" v-model="adult_fee" min="0.00" max="100.00"/>
                                    </div>
                                </div>

                                <div class="mt-3" >
                                    <label class="text-left w-100" style="text-align: left;"><b>Child Fee*</b></label>
                                    <div class="mt-3">
                                        <input type="number" step="0.01" class="border w-100 p-2" v-model="child_fee" min="0.00" max="100.00"/>
                                    </div>
                                </div>

                                <div class="mt-3" >
                                    <label class="text-left w-100" style="text-align: left;"><b>Infant Fee*</b></label>
                                    <div class="mt-3">
                                        <input type="number" step="0.01" class="border w-100 p-2" v-model="infant_fee" min="0.00" max="100.00"/>
                                    </div>
                                </div>

                                <div class="mt-3" >
                                    <label class="text-left w-100" style="text-align: left;"><b>Adult Fee Min*</b></label>
                                    <div class="mt-3">
                                        <input type="number" step="0.01" class="border w-100 p-2" v-model="adult_fee_min" min="0.00" max="100.00"/>
                                    </div>
                                </div>

                                <div class="mt-3" >
                                    <label class="text-left w-100" style="text-align: left;"><b>Child Fee Min*</b></label>
                                    <div class="mt-3">
                                        <input type="number" step="0.01" class="border w-100 p-2" v-model="child_fee_min" min="0.00" max="100.00"/>
                                    </div>
                                </div>

                                <div class="mt-3" >
                                    <label class="text-left w-100" style="text-align: left;"><b>Infant Fee Min*</b></label>
                                    <div class="mt-3">
                                        <input type="number" step="0.01" class="border w-100 p-2" v-model="infant_fee_min" min="0.00" max="100.00"/>
                                    </div>
                                </div>

                                <div class="mt-3" >
                                    <label class="text-left w-100" style="text-align: left;"><b>Provider Cost*</b></label>
                                    <div class="mt-3">
                                        <input type="number" class="border w-100 p-2" v-model="provider_cost" min="0" max="1"/>
                                    </div>
                                </div>

                                <div class="mt-3" >
                                    <label class="text-left w-100" style="text-align: left;"><b>Country Geounit ID</b></label>
                                    <div class="mt-3">
                                        <select v-model="country_geounit_id" class="border w-100 p-2">
                                        <option v-for="option in countries_geounit_id" v-bind:value="option.value" :key="option.value">
                                            {{ option.text }}
                                        </option>
                                        </select>
                                    </div>
                                </div>
                                
                            </div>
                            </form>
                        </slot>
                    </div>
                    <span v-if="saveResponse != null">
                        <div class="dropdown-divider"></div>
                        <span v-for="singleError in saveResponse" :key="singleError"> 
                            <div class="alert alert-success" role="alert" v-if="singleError==='Ok'">Campo insertado / editado con éxito</div>
                            <div class="alert alert-danger" role="alert"  v-else>
                                <p> {{singleError}} </p>
                            </div>
                        </span>
                    </span>
                    <div class="dropdown-divider"></div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary text-black" style="background-color: #f5f5f5; border: 1px solid gray;" data-dismiss="modal" @click="close()">Cerrar</button>
                        <button type="button" class="btn btn-success text-white mx-2" style="border: 1px solid gray;" @click="save()">{{ actionType }}</button>
                    </div>
                </div>
            </div>
        </div>
        <h1 class="py-4">Gestión de reglas de fees</h1>
        <div class="col-md-12 py-4">
            <button type="button" @click="insert()" class="btn btn-primary text-white" data-toggle="modal" data-target="#newmodal">Añadir regla</button>
            <button type="button" @click="csvExport()" class="btn btn-success text-white mx-2">Exportar a Excel</button>
        </div>
        <select v-model="selected" class="mx-auto m-4 block table table-striped table-bordered table-condensed w-75" id="itemsPerPage" @change="changeItemsPerPage()">
            <option v-for="option in selectItems" v-bind:value="option.value" :key="option.value">
                {{ option.text }}
            </option>
        </select>
        <div class="w-75 text-right container py-4" style="text-align: right;">
            <button type="button" @click="changeExtendedView" class="btn btn-primary text-white">{{ extendedViewText }}</button>
        </div>
        <span v-if="dropResponse != null">
            <span v-for="singleError in dropResponse" :key="singleError"> 
                <div class="alert alert-success" role="alert" v-if="singleError==='Ok'">Campo eliminado con éxito</div>
                <div class="alert alert-danger" role="alert" show variant="danger" v-else>
                    <p> {{singleError}} </p>
                </div>
            </span>
        </span>
        <v-table :data="data" :filters="filters" selectionMode="multiple"
        :currentPage.sync="currentPage" :pageSize="pageSize" @totalPagesChanged="totalPages = $event" @selectionChanged="selectedRows = $event" class="border mx-auto block text-center table table-striped table-bordered table-condensed w-75" :rows-per-page-items="opts">
            <thead slot="head" class="border border-secondary p-2">
                <tr>
                    <td v-if="extendedView === true" class="border p-2"><input class="form-control" v-model="filters.name.value"/></td>
                    <td class="border p-2"><input class="form-control" v-model="filters.remite.value"/></td>
                    <td class="border p-2"><input class="form-control" v-model="filters.provider_id.value"/></td>
                    <td class="border p-2"><input class="form-control" v-model="filters.provider_iata.value"/></td>
                    <td class="border p-2"><input class="form-control" v-model="filters.system.value"/></td>
                    <td v-if="extendedView === true" class="border p-2"><input class="form-control" v-model="filters.market_id.value"/></td>
                    <td v-if="extendedView === true" class="border p-2"><input class="form-control" v-model="filters.route_type.value"/></td>
                    <td v-if="extendedView === true" class="border p-2"><input class="form-control" v-model="filters.airline_iata.value"/></td>
                    <td v-if="extendedView === true" class="border p-2"><input class="form-control" v-model="filters.geounit_origin_id.value"/></td>
                    <td v-if="extendedView === true" class="border p-2"><input class="form-control" v-model="filters.geounit_destination_id.value"/></td>
                    <td v-if="extendedView === true" class="border p-2"><input class="form-control" v-model="filters.application_fee.value"/></td>
                    <td v-if="extendedView === true" class="border p-2"><input class="form-control" v-model="filters.passenger_type.value"/></td>
                    <td v-if="extendedView === true" class="border p-2"><input class="form-control" v-model="filters.fee_type.value"/></td>
                    <td class="border p-2"><input class="form-control" v-model="filters.adult_fee.value"/></td>
                    <td v-if="extendedView === true" class="border p-2"><input class="form-control" v-model="filters.child_fee.value"/></td>
                    <td v-if="extendedView === true" class="border p-2"><input class="form-control" v-model="filters.infant_fee.value"/></td>
                    <td v-if="extendedView === true" class="border p-2"><input class="form-control" v-model="filters.adult_fee_min.value"/></td>
                    <td v-if="extendedView === true" class="border p-2"><input class="form-control" v-model="filters.child_fee_min.value"/></td>
                    <td v-if="extendedView === true" class="border p-2"><input class="form-control" v-model="filters.infant_fee_min.value"/></td>
                    <td v-if="extendedView === true" class="border p-2"><input class="form-control" v-model="filters.provider_cost.value"/></td>
                    <td v-if="extendedView === true" class="border p-2"><input class="form-control" v-model="filters.country_geounit_id.value"/></td>
                    <td v-if="extendedView === true" class="border p-2"><input class="form-control" v-model="filters.created.value"/></td>
                    <td v-if="extendedView === true" class="border p-2"><input class="form-control" v-model="filters.updated.value"/></td>
                    <td class="border p-2"></td>
                </tr>
                <tr>
                    <v-th v-if="extendedView === true" sortKey="name" class="border p-2 bg-info text-white" style="cursor: pointer;">Name</v-th>
                    <v-th sortKey="remite" class="border p-2 bg-info text-white" style="cursor: pointer;">Remite</v-th>
                    <v-th sortKey="provider_id" class="border p-2 bg-info text-white" style="cursor: pointer;">Provider Id</v-th>
                    <v-th sortKey="provider_iata" class="border p-2 bg-info text-white" style="cursor: pointer;">Provider IATA</v-th>
                    <v-th sortKey="system" class="border p-2 bg-info text-white" style="cursor: pointer;">System</v-th>
                    <v-th v-if="extendedView === true" sortKey="market_id" class="border p-2 bg-info text-white" style="cursor: pointer;">Market ID</v-th>
                    <v-th v-if="extendedView === true" sortKey="route_type" class="border p-2 bg-info text-white" style="cursor: pointer;">Route Type</v-th>
                    <v-th v-if="extendedView === true" sortKey="airline_iata" class="border p-2 bg-info text-white" style="cursor: pointer;">Airline IATA</v-th>
                    <v-th v-if="extendedView === true" sortKey="geounit_origin_id" class="border p-2 bg-info text-white" style="cursor: pointer;">Geounit Origin ID</v-th>
                    <v-th v-if="extendedView === true" sortKey="geounit_destination_id" class="border p-2 bg-info text-white" style="cursor: pointer;">Geounit Destination ID</v-th>
                    <v-th v-if="extendedView === true" sortKey="application_fee" class="border p-2 bg-info text-white" style="cursor: pointer;">Application Fee</v-th>
                    <v-th v-if="extendedView === true" sortKey="passenger_type" class="border p-2 bg-info text-white" style="cursor: pointer;">Passenger Type</v-th>
                    <v-th v-if="extendedView === true" sortKey="fee_type" class="border p-2 bg-info text-white" style="cursor: pointer;">Fee Type</v-th>
                    <v-th sortKey="adult_fee" class="border p-2 bg-info text-white" style="cursor: pointer;">Adult Fee</v-th>
                    <v-th v-if="extendedView === true" sortKey="child_fee" class="border p-2 bg-info text-white" style="cursor: pointer;">Child Fee</v-th>
                    <v-th v-if="extendedView === true" sortKey="infant_fee" class="border p-2 bg-info text-white" style="cursor: pointer;">Infant Fee</v-th>
                    <v-th v-if="extendedView === true" sortKey="adult_fee_min" class="border p-2 bg-info text-white" style="cursor: pointer;">Adult Fee Min</v-th>
                    <v-th v-if="extendedView === true" sortKey="child_fee_min" class="border p-2 bg-info text-white" style="cursor: pointer;">Child Fee Min</v-th>
                    <v-th v-if="extendedView === true" sortKey="infant_fee_min" class="border p-2 bg-info text-white" style="cursor: pointer;">Infant Fee Min</v-th>
                    <v-th v-if="extendedView === true" sortKey="provider_cost" class="border p-2 bg-info text-white" style="cursor: pointer;">Provider Cost</v-th>
                    <v-th v-if="extendedView === true" sortKey="country_geounit_id" class="border p-2 bg-info text-white" style="cursor: pointer;">Country Geounit ID</v-th>
                    <v-th v-if="extendedView === true" sortKey="created" class="border p-2 bg-info text-white" style="cursor: pointer;">Created</v-th>
                    <v-th v-if="extendedView === true" sortKey="updated" class="border p-2 bg-info text-white" style="cursor: pointer;">Updated</v-th>
                    <th class="border p-2 bg-info text-white" style="min-width: 100px;">Acciones</th>
                </tr>
            </thead>
            <tbody slot="body" slot-scope="{displayData}">
                <tr v-for="row in displayData" :key="row.id" class="border p-2">
                    <td v-if="extendedView === true" class="border p-2">{{ row.name }}</td>
                    <td class="border p-2">{{ row.remite_user_value }}</td>
                    <td class="border p-2">{{ row.provider_id_user_value }}</td>
                    <td class="border p-2">{{ row.provider_iata_user_value }}</td>
                    <td class="border p-2">{{ row.system_user_value }}</td>
                    <td v-if="extendedView === true" class="border p-2">{{ row.market_id_user_value }}</td>
                    <td v-if="extendedView === true" class="border p-2">{{ row.route_type_user_value }}</td>
                    <td v-if="extendedView === true" class="border p-2">{{ row.airline_iata_user_value }}</td>
                    <td v-if="extendedView === true" class="border p-2">{{ row.geounit_origin_id_user_value }}</td>
                    <td v-if="extendedView === true" class="border p-2">{{ row.geounit_destination_id_user_value }}</td>
                    <td v-if="extendedView === true" class="border p-2">{{ row.application_fee_user_value }}</td>
                    <td v-if="extendedView === true" class="border p-2">{{ row.passenger_type }}</td>
                    <td v-if="extendedView === true" class="border p-2">{{ row.fee_type_user_value }}</td>
                    <td class="border p-2">{{ row.adult_fee }}</td>
                    <td v-if="extendedView === true" class="border p-2">{{ row.child_fee }}</td>
                    <td v-if="extendedView === true" class="border p-2">{{ row.infant_fee }}</td>
                    <td v-if="extendedView === true" class="border p-2">{{ row.adult_fee_min }}</td>
                    <td v-if="extendedView === true" class="border p-2">{{ row.child_fee_min }}</td>
                    <td v-if="extendedView === true" class="border p-2">{{ row.infant_fee_min }}</td>
                    <td v-if="extendedView === true" class="border p-2">{{ row.provider_cost_user_value }}</td>
                    <td v-if="extendedView === true" class="border p-2">{{ row.country_geounit_id_user_value }}</td>
                    <td v-if="extendedView === true" class="border p-2">{{ row.created }}</td>
                    <td v-if="extendedView === true" class="border p-2">{{ row.updated }}</td>
                    <td class="border p-2">
                        <button @click="edit(row.id)" :data-id="row.id" class="act-edit" style="text-decoration: none; min-width: initial; width: 30px">
                            <span class="button__content"><span aria-hidden="true" class="v-icon notranslate theme--light"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true" class="v-icon__svg"><path d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z"></path></svg></span></span>
                        </button >
                        <span class="mx-2"></span>
                        <button @click="drop(row.id)" :data-id="row.id" class="act-delete" style="text-decoration: none; min-width: initial; width: 30px">
                            <span class="text-dark" style="font-size: 20px;">
                                <span class="button__content"><span class="text-dark" style="font-size: 20px;"><span aria-hidden="true" class="v-icon notranslate theme--light"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true" class="v-icon__svg"><path d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z"></path></svg></span></span></span>
                            </span>
                        </button >
                    </td>
                </tr>
            </tbody>
        </v-table>
        <span class="border mx-auto block text-center table table-striped table-bordered table-condensed w-75" >
            <smart-pagination
                v-model="currentPage"
                class="my-4"
                :currentPage.sync="currentPage"
                :pageSize="pageSize"
                :totalPages="totalPages"
                @totalPagesChanged="totalPages = $event"
                :maxPageLinks="10"
                :boundaryLinks="true"
            ></smart-pagination>
        </span>     
    </div>
</template>
<script>
import VTable from './VTable.vue'
import VTh from './VTh.vue'
import SmartPagination from './SmartPagination.vue'

export default {
  name: 'DataTable',
  components: {
    VTable, VTh, SmartPagination
  },
  data: () => ({
    data: [],
    
        dataFiltered: [],
        filters: {
            name: { value: '', keys: ['name'] },
            remite: { value: '', keys: ['remite_user_value'] },
            provider_id: { value: '', keys: ['provider_id_user_value'] },
            provider_iata: { value: '', keys: ['provider_iata_user_value'] },
            system: { value: '', keys: ['system_user_value'] },
            market_id: { value: '', keys: ['market_id_user_value'] },
            route_type: { value: '', keys: ['route_type_user_value'] },
            airline_iata: { value: '', keys: ['airline_iata_user_value'] },
            geounit_origin_id: { value: '', keys: ['geounit_origin_id_user_value'] },
            geounit_destination_id: { value: '', keys: ['geounit_destination_id_user_value'] },
            application_fee: { value: '', keys: ['application_fee_user_value'] },
            passenger_type: { value: '', keys: ['passenger_type'] },
            fee_type: { value: '', keys: ['fee_type_user_value'] },
            adult_fee: { value: '', keys: ['adult_fee'] },
            child_fee: { value: '', keys: ['child_fee'] },
            infant_fee: { value: '', keys: ['infant_fee'] },
            adult_fee_min: { value: '', keys: ['adult_fee_min'] },
            child_fee_min: { value: '', keys: ['child_fee_min'] },
            infant_fee_min: { value: '', keys: ['infant_fee_min'] },
            provider_cost: { value: '', keys: ['provider_cost_user_value'] },
            country_geounit_id: { value: '', keys: ['country_geounit_id_user_value'] },
            created: { value: '', keys: ['created'] },
            updated: { value: '', keys: ['updated'] }
        },
        order: 'asc',
        currentPage: 1,
        totalPages: 0,
        opts: [15, 30, 50, 100, -1],
        selectItems: [   
            {"value": null, "text": "Elementos por página", disabled: true},
            {"value": 15, "text": "15"},
            {"value": 30, "text": "30"},
            {"value": 50, "text": "50"},
            {"value": 100, "text": "100"},
            {"value": -1, "text": "Todos"}
        ],
        selectedRows: [],
        selected: null,
        nameConnectors: [],
        markets: [],
        pageSize: 15,
        dialog: false,
        name: null,
        remite: null,
        market_id: null,
        route_type: null,
        airline_iata: null,
        geounits_origin_id: null,
        geounit_destination_id: null,
        geounits_destination_id: null,
        passenger_type: null,
        fee_type: null,
        adult_fee: null,
        child_fee: null,
        infant_fee: null,
        adult_fee_min: null,
        child_fee_min: null,
        infant_fee_min: null,
        provider_cost: null,
        country_geounit_id: null,
        countries_geounit_id: null,
        application_fee: null,
        provider_id: null,
        provider_iata: null,
        system: null,
        geounit_origin_id: null,
        dateStart: null,
        dateEnd: null,
        extendedView: false,
        extendedViewText: 'Vista extendida',
        actionType: '',
        saveResponse: null,
        dropResponse: null,
        feesRuleId: null,
        provider_iatas_arrays: null,
        created: null,
        providers: [   
            {"value": "-1", "text": "Select Provider", disabled: true},
            {"value": "1042", "text": "AMADEUS"},
            {"value": "52266", "text": "CTW"},
            {"value": "30619", "text": "KIWI"},
            {"value": "31414", "text": "NDC"},
            {"value": "451", "text": "TRAVELFUSION"},
            {"value": "12446", "text": "MYSTIFLY"},
            {"value": null, "text": "TODOS"}
        ],
        provider_iatas: [
            {"value": null, "text": "Select IATA", disabled: true},
        ],
        systems: [
            {"value": null, "text": "Select System", disabled: true},
            {"value": "1", "text": "VUELO"},
            {"value": "2", "text": "V + H"},
        ],
        markets: [
            {"value": null, "text": "Select Market", disabled: true},
            
        ],
        route_types: [
            {"value": null, "text": "Select Route Type", disabled: true},
            {"value": "national", "text": "National"},
            {"value": "intracontinental", "text": "Intracontinental"},
            {"value": "intercontinental", "text": "Intercontinental"},
            {"value": null, "text": "TODOS"},
        ],
        application_fees: [
            {"value": null, "text": "Select Application Fee", disabled: true},
            {"value": "passenger", "text": "Passenger"},
            {"value": "expedient", "text": "Expedient"},
        ],
        fee_types: [
            {"value": null, "text": "Select Fee Type", disabled: true},
            {"value": "fixed", "text": "Fixed"},
            {"value": "percentage", "text": "Percentage"},
        ],
  }),
  beforeMount () {
      this.passenger_type = 1,
      this.adult_fee = 0.00,
      this.adult_fee_min = 0.00,
      this.child_fee = 0.00,
      this.child_fee_min = 0.00,
      this.infant_fee = 0.00,
      this.infant_fee_min = 0.00,
      this.provider_cost = 1
  },
  mounted () {
        fetch(`https://res.hotelkey.com/res/mvc.php/%5Cadmin%5Cprovider_fees%5CSPA%5CController%5CApi/ProviderFeesApi/getfeesrules`)
        .then(res => res.json())
        .then(data => {this.data = data.data; })
        .catch(err => console.log(err.message));

        fetch(`https://res.hotelkey.com/res/mvc.php/%5Cadmin%5Cprovider_fees%5CSPA%5CController%5CApi/ProviderFeesApi/getcountries`)
        .then(res => res.json())
        .then(data => {this.geounits_origin_id = data.data; })
        .catch(err => console.log(err.message));
        
        fetch(`https://res.hotelkey.com/res/mvc.php/%5Cadmin%5Cprovider_fees%5CSPA%5CController%5CApi/ProviderFeesApi/getcountries`)
        .then(res => res.json())
        .then(data => {this.geounits_destination_id = data.data; })
        .catch(err => console.log(err.message));

        fetch(`https://res.hotelkey.com/res/mvc.php/%5Cadmin%5Cprovider_fees%5CSPA%5CController%5CApi/ProviderFeesApi/getcountries`)
        .then(res => res.json())
        .then(data => {this.countries_geounit_id = data.data; })
        .catch(err => console.log(err.message));

        fetch(`https://res.hotelkey.com/res/mvc.php/%5Cadmin%5Cprovider_fees%5CSPA%5CController%5CApi/ProviderFeesApi/getprovidersiata`)
        .then(res => res.json())
        .then(data => {this.provider_iatas_arrays = data.data; })
        .catch(err => console.log(err.message));

        fetch(`https://res.hotelkey.com/res/mvc.php/%5Cadmin%5Cprovider_fees%5CSPA%5CController%5CApi/ProviderFeesApi/getmarketsid`)
        .then(res => res.json())
        .then(data => {this.markets = data.data; })
        .catch(err => console.log(err.message));
    },
  methods: {
        csvExport() {
            var arrData = this.getDataFiltered();
            let csvContent = "data:text/csv;charset=utf-8,";
            csvContent += [
            Object.keys(arrData[0]).join(";"),
            ...arrData.map(item => Object.values(item).join(";"))
            ]
            .join("\n")
            .replace(/(^\[)|(\]$)/gm, "");
            
            const csvData = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", csvData);
            link.setAttribute("download", "export.csv");
            link.click();
            
        },
        changeItemsPerPage (){
            if (this.selected == null){
                this.pageSize = 15;    
            }else{
                this.pageSize = this.selected;
            }
        },
        save() {
            fetch(`https://res.hotelkey.com/res/mvc.php/%5Cadmin%5Cprovider_fees%5CSPA%5CController%5CApi/ProviderFeesApi/addNewRule`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    feesRuleId: this.feesRuleId,
                    name: this.name,
                    remite: this.remite,
                    provider_id: this.provider_id,
                    provider_iata: this.provider_iata,
                    system: this.system,
                    market_id: this.market_id,
                    route_type: this.route_type,
                    airline_iata: this.airline_iata,
                    geounit_origin_id: this.geounit_origin_id,
                    geounit_destination_id: this.geounit_destination_id,
                    application_fee: this.application_fee,
                    passenger_type: this.passenger_type,
                    fee_type: this.fee_type,
                    adult_fee: this.adult_fee,
                    child_fee: this.child_fee,
                    infant_fee: this.infant_fee,
                    adult_fee_min: this.adult_fee_min,
                    child_fee_min: this.child_fee_min,
                    infant_fee_min: this.infant_fee_min,
                    provider_cost: this.provider_cost,
                    country_geounit_id: this.country_geounit_id,
                    created: this.created
                })
            })
            .then((response) => response.json())
            .then(data => { this.saveResponse = data.data})
            .catch(err => console.log(err.message));
            
        },
        insert() {
            this.actionType = 'Insertar';
            this.dialog = true;
        },
        edit(ruleID) {
            this.actionType = 'Editar';
            var arrData = this.searchExactData({ id: ruleID});
            this.feesRuleId = ruleID;
            this.name = arrData[0].name;
            this.remite = arrData[0].remite;
            this.provider_id = arrData[0].provider_id;
            this.provider_iata = arrData[0].provider_iata;
            this.system = arrData[0].system;
            this.market_id = arrData[0].market_id;
            this.route_type = arrData[0].route_type;
            this.airline_iata = arrData[0].airline_iata;
            this.geounit_origin_id = arrData[0].geounit_origin_id;
            this.geounit_destination_id = arrData[0].geounit_destination_id;
            this.application_fee = arrData[0].application_fee;
            this.passenger_type = arrData[0].passenger_type;
            this.fee_type = arrData[0].fee_type;
            this.adult_fee = arrData[0].adult_fee;
            this.child_fee = arrData[0].child_fee;
            this.infant_fee = arrData[0].infant_fee;
            this.adult_fee_min = arrData[0].adult_fee_min;
            this.child_fee_min = arrData[0].child_fee_min;
            this.infant_fee_min = arrData[0].infant_fee_min;
            this.provider_cost = arrData[0].provider_cost;
            this.country_geounit_id = arrData[0].country_geounit_id;
            this.created = arrData[0].created;
            this.dialog = true;
        },
        drop(ruleID) {
            this.feesRuleId = ruleID;
            
            fetch(`https://res.hotelkey.com/res/mvc.php/%5Cadmin%5Cprovider_fees%5CSPA%5CController%5CApi/ProviderFeesApi/dropRule`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    feesRuleId: this.feesRuleId
                })
            })
            .then((response) => response.json())
            .then(data => { this.dropResponse = data.data})
            .then(setTimeout(function(){ location.reload(); }, 1500))
            .catch(err => console.log(err.message));

        },
        searchFilteredData(filters) {
            return this.data.filter(function (o) {
                return Object.keys(filters).every(function (k) {
                    o[k] = String(o[k]);
                    return o[k].toLowerCase().split(',').some(function (v) {
                        return v.toLowerCase().includes(filters[k].toLowerCase());
                    });
                });
            });
        },
        getDataFiltered () {
            var name = this.filters.name.value ? this.filters.name.value : '';
            var remite = this.filters.remite.value ? this.filters.remite.value : '';
            var provider_id = this.filters.provider_id.value ? this.filters.provider_id.value : '';
            var provider_iata = this.filters.provider_iata.value ? this.filters.provider_iata.value : '';
            var system = this.filters.system.value ? this.filters.system.value : '';
            var market_id = this.filters.market_id.value ? this.filters.market_id.value : '';
            var route_type = this.filters.route_type.value ? this.filters.route_type.value : '';
            var airline_iata = this.filters.airline_iata.value ? this.filters.airline_iata.value : '';
            var geounit_origin_id = this.filters.geounit_origin_id.value ? this.filters.geounit_origin_id.value : '';
            var geounit_destination_id = this.filters.geounit_destination_id.value ? this.filters.geounit_destination_id.value : '';
            var application_fee = this.filters.application_fee.value ? this.filters.application_fee.value : '';
            var passenger_type = this.filters.passenger_type.value ? this.filters.passenger_type.value : '';
            var fee_type = this.filters.fee_type.value ? this.filters.fee_type.value : '';
            var adult_fee = this.filters.adult_fee.value ? this.filters.adult_fee.value : '';
            var child_fee = this.filters.child_fee.value ? this.filters.child_fee.value : '';
            var infant_fee = this.filters.infant_fee.value ? this.filters.infant_fee.value : '';
            var adult_fee_min = this.filters.adult_fee_min.value ? this.filters.adult_fee_min.value : '';
            var child_fee_min = this.filters.child_fee_min.value ? this.filters.child_fee_min.value : '';
            var infant_fee_min = this.filters.infant_fee_min.value ? this.filters.infant_fee_min.value : '';
            var provider_cost = this.filters.provider_cost.value ? this.filters.provider_cost.value : '';
            var country_geounit_id = this.filters.country_geounit_id.value ? this.filters.country_geounit_id.value : '';
            var created = this.filters.created.value ? this.filters.created.value : '';
            var updated = this.filters.updated.value ? this.filters.updated.value : '';
            
            return this.searchFilteredData({ name: name, remite: remite, provider_id: provider_id, provider_iata:  provider_iata, system: system, market_id: market_id, route_type: route_type, airline_iata: airline_iata, geounit_origin_id: geounit_origin_id, geounit_destination_id: geounit_destination_id, application_fee: application_fee, passenger_type: passenger_type, fee_type: fee_type, adult_fee: adult_fee, child_fee: child_fee, infant_fee: infant_fee, adult_fee_min: adult_fee_min, child_fee_min: child_fee_min, infant_fee_min: infant_fee_min, provider_cost: provider_cost, country_geounit_id: country_geounit_id, created: created, updated: updated});
        },
        searchExactData(filters) {
            return this.data.filter(function (o) {
                return Object.keys(filters).every(function (k) {
                    return o[k].toLowerCase().split(',').some(function (v) {
                        return v.toLowerCase() == filters[k].toLowerCase();
                    });
                });
            });
        },
        changeExtendedView () {
            if (this.extendedView){
                this.extendedView = false;
                this.extendedViewText = 'Vista extendida';
            }else{
                this.extendedView = true;
                this.extendedViewText = 'Vista compacta';
            }
            
        },
        close () {
            this.dialog = false;
            if (this.saveResponse != null){
                location.reload();
            }
        },
        updateProviderIATA () {
            if (this.provider_id != null) {
                this.provider_iatas = this.provider_iatas_arrays[this.provider_id];
            }
        }
    },
}
</script>
<style scope>
ul.pagination{
    align-items: center;
    display: inline-flex;
    list-style-type: none;
    justify-content: center;
    margin: 0;
    max-width: 100%;
    width: 100%;
}
select{
    padding: .5rem !important;
    width: 100%;
    border: 1px solid #dee2e6 !important;
    background-color: transparent;
    border-style: none;
    text-transform: none;
    font-size: 18px;
    cursor: pointer;
}
#itemsPerPage{
    border: none !important;
    border-bottom: 1px solid gray !important;
}
.modal-dialog {
    position: relative;
    width: auto;
    margin: .5rem;
    pointer-events: none;
}
.modal.show .modal-dialog {
    -webkit-transform: translate(0,0);
    transform: translate(0,0);
}
.modal.fade .modal-dialog {
    transition: -webkit-transform .3s ease-out;
    transition: transform .3s ease-out;
    transition: transform .3s ease-out,-webkit-transform .3s ease-out;
}
.modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
}
.modal-dialog {
    position: relative;
    width: auto;
    margin: .5rem;
    pointer-events: none;
    margin-right: auto;
    margin-left: auto;
}
*, ::after, ::before {
    box-sizing: border-box;
}
.modal-open .modal {
    overflow-x: hidden;
    overflow-y: auto;
}
.fade.show {
    opacity: 1;
}
.modal {
    z-index: 1072;
}
.modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    outline: 0;
}
.fade {
    transition: opacity .15s linear;
}
</style>